<template lang="html">
    <div class="auth-layout">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="stylus" scoped>
@require '../../assets/css/variables'
    div.auth-layout {
        display: flex
        justify-content: center
        align-items: center
        height: 100vh
        width: 100vw
        background: #fafafa
        &::before {
            position: fixed
            bottom:1%
            height: 100vh
            width: 100vw
            content: ''
            background: url('../../assets/img/logo_s_grey.svg') center no-repeat
            background-size: 80% auto
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/auth/Layout.vue